import { render, staticRenderFns } from "./TotalCard.vue?vue&type=template&id=54b5d372&"
import script from "./TotalCard.vue?vue&type=script&lang=js&"
export * from "./TotalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports